import React, { ReactElement } from 'react';
import { Grid } from '@mui/material';
import LiveAgentWrapper from './LiveAgentWrapper';
import commonCss from '../common/CommonStyles.module.css';

/**
 * LiveAgent.styles.css needs to be imported from the _app file for the styles to work
 * To see the Embedded Service Chat documentation go here --> https://developer.salesforce.com/docs/atlas.en-us.snapins_web_dev.meta/snapins_web_dev/snapins_web_overview.htm
 */

declare global {
  interface Window {
    embedded_svc: {
      settings: {
        displayHelpButton: boolean;
        autoOpenPostChat: boolean;
        language: string;
        storageDomain: string;
        enabledFeatures: Array<string>;
        entryFeature: string;
        smallCompanyLogoImgURL: string;
        avatarImgURL: string;
        prepopulatedPrechatFields: { origin: string };
      };
      init: (...params: Array<unknown>) => void;
      addEventHandler: (...params: Array<unknown>) => void;
      bootstrapEmbeddedService: () => void;
    };
  }
}

const ChatLiveAgent = (): ReactElement | null => (
    <Grid item className={commonCss?.contactUsBtnGridItem}>
      <LiveAgentWrapper />
    </Grid>
  );

export default ChatLiveAgent;
